module.exports = __webpack_public_path__ + "img/orange-rectangle-table-8.000e1dd7.png";